let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("eeaKR"), load("b02wj")]).then(() => parcelRequire('5Sq8i'));